import type { MessagingGetChatRoomById200LastMessageBasicInfoAllOfTwoType } from './messagingGetChatRoomById200LastMessageBasicInfoAllOfTwoType';

/**
 * 메시지 기본 정보
 */
export type MessagingGetChatRoomById200LastMessageBasicInfoAllOfTwo = {
  content?: string;
  type?: MessagingGetChatRoomById200LastMessageBasicInfoAllOfTwoType;
};
